import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Check, Plus } from 'lucide-react';

type User = { id: string; name: string };

export default function MemberSelect({
  projectId,
  role,
  assigned,
  teamUsers,
  onAssign,
  onUnassign,
}: {
  projectId: string;
  role: string;
  assigned: User[];
  teamUsers: User[];
  onAssign: (projectId: string, userId: string, role: string) => void;
  onUnassign: (projectId: string, userId: string, role: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const assignedIds = new Set(assigned.map((u) => u.id));

  return (
    <div className="flex flex-wrap gap-1 items-center">
      {assigned.map((user) => (
        <Badge key={user.id} variant={'secondary'} className="text-xs">
          {user.name}
        </Badge>
      ))}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant={'ghost'}
            size={'sm'}
            className="h-6 w-6 p-0 cursor-pointer"
          >
            <Plus className="h-3 w-3" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-48 p-2">
          {teamUsers.map((user) => (
            <Button
              variant={'ghost'}
              key={user.id}
              className="cursor-pointer"
              onClick={() => {
                if (assignedIds.has(user.id)) {
                  onUnassign(projectId, user.id, role);
                } else {
                  onAssign(projectId, user.id, role);
                }
              }}
            >
              {assignedIds.has(user.id) && <Check className="h-3 w-3" />}
              <span className={assignedIds.has(user.id) ? '' : 'ml-5'}>
                {user.name}
              </span>
            </Button>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  );
}
